import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FinanceWalletModel} from '../../../models/finance.model';
import {PaymentTransactionModel} from '../../../models/contract.model';
import {FinanceService} from '../../../services/api/finance.service';
import {AlertService} from '../../../services/notify/alert.service';
import {ModalService} from '../../../services/modal/modal.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-payout',
    templateUrl: './payout.component.html',
    styleUrls: ['./payout.component.scss'],
})
export class PayoutComponent implements OnInit, AfterViewInit {
    @ViewChild('payoutView') public payoutView;
    @Input() public wallet: FinanceWalletModel;
    @Output() public emitFinish: EventEmitter<boolean> = new EventEmitter<boolean>();

    isLockButton = false;

    constructor(
        protected financeService: FinanceService,
        protected alert: AlertService,
        protected modalService: ModalService,
        protected translate: TranslateService,
    ) {
    }

    ngOnInit(): void {
        const sub = this.modalService.emitOnClose.subscribe(() => {
            this.emitFinish.emit();
            sub.unsubscribe();
        });
    }

    ngAfterViewInit(): void {
        this.modalService.openTemplateModal(this.payoutView);
    }

    onPayoutEvent($total, $bankAcc, modal: NgbModalRef = null): void {
        if (!$total.value || !$bankAcc.value) {
            this.alert.setAlert(this.translate.instant('ALERTS.PAYOUT'), 'blue');
        } else {
            this.isLockButton = true;
            this.financeService.createPayoutTransaction(this.wallet.guid, $total.value, $bankAcc.value)
                .subscribe({
                    next: (res: { transaction: PaymentTransactionModel }) => {
                        this.alert.setAlert(this.translate.instant('ALERTS.NEW_TRANSACTION',
                            {guid: res.transaction.guid, total: res.transaction.total}), 'green');
                        this.emitFinish.emit(true);
                        modal.close();
                        setTimeout(() => {
                            this.isLockButton = false;
                        }, 500);
                    }, error: error => {
                        this.alert.setAlert(error.message, 'blue');
                        this.isLockButton = false;
                    },
                });
        }
    }
}
